import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

interface ContactInformationTemplateProps {
  mobilePhoneNumberComponent: React.JSX.Element;
  landlineNumberComponent: React.JSX.Element;
  emailComponent: React.JSX.Element;
}

export default function ContactInformationTemplate({ mobilePhoneNumberComponent, landlineNumberComponent, emailComponent }: ContactInformationTemplateProps): React.JSX.Element {
  const { t } = useTranslation(['common']);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: 1.5,
        py: 2,
      }}
    >
      <Box>
        <Typography variant="titleSmall">
          📱 {t('common:mobile_phone')}
        </Typography>
        {mobilePhoneNumberComponent}
      </Box>
      <Box>
        <Typography variant="titleSmall">
          ☎️ {t('common:landline_phone')}
        </Typography>
        {landlineNumberComponent}
      </Box>
      <Box>
        <Typography variant="titleSmall">
          ✉️ {t('common:email_address')}
        </Typography>
        {emailComponent}
      </Box>
    </Box>
  );
}
